import { jsx, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useSelectContext } from '../context.mjs';

function SelectCapturedActiveValue(props) {
  const context = useSelectContext();
  const capturedActiveValue = useMemo(
    () => context.value,
    // 셀렉트가 열리는 시점에 선택 되어 있는 옵션값을 캡쳐 합니다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return /* @__PURE__ */ jsx(Fragment, { children: props.children({ value: capturedActiveValue }) });
}

export { SelectCapturedActiveValue };
//# sourceMappingURL=CapturedActiveValue.mjs.map
